<i18n>
{
  "en": {
    "video_search": "Find Movies",
    "sort_label": "Sort Order",
    "sort_newest": "Newest",
    "sort_oldest": "Oldest",
    "sort_popular": "Popular",
    "movie_status": "Status",
    "status_vip": "VIP",
    "status_svip": "SVIP",
    "status_annual": "Annual",
    "movie_type": "Type",
    "type_vr": "VR",
    "type_fhd": "Full HD",
    "type_hd": "HD",
    "type_60fps": "60 fps",
    "other": "Other",
    "category_list": "Categories",
    "categories": "Categories",
    "series": "Series",
    "actresses": "Girls",
    "site_guide": "Site Guide",
    "faq": "FAQ",
    "contact": "Contact",
    "site_map": "Site Map",
    "recommended_sites": "Recommended Sites",
    "site_carib": "Caribbeancom",
    "site_caribpr": "Caribbeancom Premium",
    "site_dxlive": "DX LIVE",
    "site_1pondo": "1pondo",
    "site_10musume": "10musume",
    "site_heyzo": "HEYZO",
    "site_paco": "Pacopacomama"
  },
  "ja": {
    "video_search": "動画検索",
    "sort_label": "並べ替え",
    "sort_newest": "新着順",
    "sort_oldest": "古い順",
    "sort_popular": "人気順",
    "movie_status": "配信ステータス",
    "status_vip": "VIP動画",
    "status_svip": "超VIP動画",
    "status_annual": "年間動画",
    "movie_type": "動画タイプ",
    "type_vr": "VR",
    "type_fhd": "Full HD",
    "type_hd": "HD",
    "type_60fps": "60 fps",
    "other": "その他",
    "category_list": "カテゴリー一覧",
    "categories": "カテゴリー",
    "series": "シリーズ一覧",
    "actresses": "女のコ検索",
    "site_guide": "サイトガイド",
    "faq": "ヘルプ",
    "contact": "お問い合わせ",
    "site_map": "サイトマップ",
    "recommended_sites": "おすすめサイト",
    "site_carib": "カリビアンコム",
    "site_caribpr": "カリビアンコムプレミアム",
    "site_dxlive": "DXLIVE",
    "site_1pondo": "一本道",
    "site_10musume": "天然むすめ",
    "site_heyzo": "HEYZO",
    "site_paco": "パコパコママ"
  }
}
</i18n>

<template>
<!-- eslint-disable vue/no-use-v-if-with-v-for -->
<div class="sidebar">
  <!-- join button -->
  <div class="sidebar-cta" v-if="!isSiteMember && locale == 'ja'">
    <router-link to="/join/"><img src="~@/assets/img/sidebar-cta-join.svg" width="224" height="64" alt=""></router-link>
  </div>

  <!-- sidebar -->
  <section class="sidebar-section">
    <div class="sidebar-section-header">{{ $t('video_search') }}</div>
    <div class="sidebar-section-body">
      <router-link class="sidebar-item" to="/list/?page=1&o=newest">{{ $t('sort_newest') }}</router-link>
      <router-link class="sidebar-item" to="/list/?page=1&o=oldest">{{ $t('sort_oldest') }}</router-link>
      <router-link class="sidebar-item" to="/list/?page=1&o=bob">{{ $t('sort_popular') }}</router-link>
    </div>
  </section>
  <section class="sidebar-section">
    <div class="sidebar-section-header">{{ $t('movie_type') }}</div>
    <div class="sidebar-section-body">
      <router-link v-if="!newXPEligible" class="sidebar-item" to="/search/?c=50000">{{ $t('status_vip') }}</router-link>
      <router-link v-if="!newXPEligible" class="sidebar-item" to="/search/?c=50001">{{ $t('status_svip') }}</router-link>
      <router-link class="sidebar-item" to="/search/?c=60000">{{ $t('type_fhd') }}</router-link>
      <router-link class="sidebar-item" to="/search/?c=60002">{{ $t('type_hd') }}</router-link>
      <router-link class="sidebar-item" to="/search/?c=60001">{{ $t('type_60fps') }}</router-link>
      <router-link class="sidebar-item" v-if="showVRFilter" :to="`/search/?c=${vrCategoryID}`">{{ $t('type_vr') }}</router-link>
    </div>
  </section>
  <section class="sidebar-section">
    <div class="sidebar-section-header">{{ $t('categories') }}</div>
    <div class="sidebar-section-body">
      <router-link
        v-for="(category, index) in categoryList"
        v-if="categoryMap[category]"
        :key="index"
        :to="`/search/?c=${categoryMap[category].category_id}`"
        class="sidebar-item">
        {{ categoryMap[category].name[locale] }}<small>({{ categoryMap[category].movie_count }})</small>
      </router-link>
      <router-link class="sidebar-item" to="/category/">{{ $t('category_list') }}<i class="iconf-keyboard-arrow-right is-right"></i></router-link>
    </div>
  </section>
  <section class="sidebar-section">
    <div class="sidebar-section-header">{{ $t('site_guide') }}</div>
    <div class="sidebar-section-body">
      <router-link class="sidebar-item" to="/faq/">{{ $t('faq') }}</router-link>
      <router-link class="sidebar-item" to="/contact/">{{ $t('contact') }}</router-link>
      <router-link class="sidebar-item" to="/sitemap/">{{ $t('site_map') }}</router-link>
    </div>
  </section>
  <section class="sidebar-section">
    <div class="sidebar-section-header">{{ $t('recommended_sites') }}</div>
    <div class="sidebar-section-body">
      <a class="sidebar-item" href="https://bit.ly/3YNngGL" target="_blank" rel="noopener">{{ $t('site_carib') }}</a>
      <a class="sidebar-item" href="https://bit.ly/3YuE7h7" target="_blank" rel="noopener">{{ $t('site_caribpr') }}</a>
      <a class="sidebar-item" href="https://bit.ly/4dqfMNR" target="_blank" rel="noopener">{{ $t('site_1pondo') }}</a>
      <a class="sidebar-item" href="https://bit.ly/4dLkRk7" target="_blank" rel="noopener">{{ $t('site_10musume') }}</a>
      <a class="sidebar-item" href="https://bit.ly/4d7grDU" target="_blank" rel="noopener">{{ $t('site_paco') }}</a>
      <a class="sidebar-item" href="https://bit.ly/3Sy9V0U" target="_blank" rel="noopener">{{ $t('site_dxlive') }}</a>
    </div>
  </section>
</div>
</template>

<script>
/* eslint max-len: 0 */
import BifrostAPI from '@/assets/js/services/Bifrost/API';

const VR_CATEGORY_ID = 94;

export default {
  data() {
    return {
      categoryMap: {},
      categoryList: [
        '熟女/人妻',
        '風俗嬢',
        '盗撮',
        '巨乳',
        'アナル',
        'パイパン',
        '10代',
        'ニューハーフ',
        '野外露出',
        'どっきり',
        '女子校生',
        'メイド',
        '女子大生',
        '乱交',
        'OL',
        '痴女',
        'SM',
        'ナンパ',
        'カップル',
      ],

      vrCategoryID: VR_CATEGORY_ID,
      showVRFilter: false,
    };
  },
  async created() {
    // get categories and map by name, so we can show a specific list of categories based on
    // the category-list attribute
    const bfAPI = new BifrostAPI();
    const categories = await bfAPI.getCategories();

    Object.keys(categories).forEach((categoryId) => {
      if (this.categoryList.includes(categories[categoryId].name.ja)) {
        this.$set(this.categoryMap, categories[categoryId].name.ja, categories[categoryId]);
      }
    });

    // show VR filter option only if VR movies exist
    if (Object.prototype.hasOwnProperty.call(categories, VR_CATEGORY_ID) && categories[VR_CATEGORY_ID].movie_count > 0) {
      this.showVRFilter = true;
    }
  },
  computed: {
    locale() {
      return this.$i18n.locale;
    },
    newXPEligible() {
      return this.$store.getters['user/isNewXPEligible'];
    },
    isSiteMember() {
      return this.$store.getters['user/isSiteMember'];
    },
  },
};
</script>

<style lang="scss" scoped>
</style>
